export interface IContentItem {
  id: string | null;
  item_key: string | null;
  name: string | null;
  label: string | null;
  value: string | null;
  position: number;
  created_at: string | null;
  updated_at: string | null;
}

export default class ContentItem implements IContentItem {
  public type = "content-items";

  id!: string | null;
  item_key!: string | null;
  name!: string | null;
  label!: string | null;
  value!: string | null;
  position!: number;
  created_at!: string | null;
  updated_at!: string | null;

  public constructor(data: IContentItem) {
    this.fill(data);
  }

  public fill(data: IContentItem) {
    this.id = data.id;
    this.item_key = data.item_key;
    this.name = data.name;
    this.label = data.label;
    this.value = data.value;
    this.position = parseInt(data.position + "") || 1;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  public static fromArray(items: IContentItem[]) {
    return items.map((item) => new ContentItem(item));
  }
}
